module.exports = __webpack_public_path__ + "static/media/heywow-bold-webfont.aa9a51f8.woff2";